module.exports = __webpack_public_path__ + "img/camera-permission-m.c9fc9239.svg";